import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import './assets/fonts/stylesheet.scss';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import router from './routes/AppRoutes';
import { AppProvider } from './contexts/AppContext';
import { RegisterProvider } from './contexts/RegisterContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppProvider>
      <RegisterProvider>
        <RouterProvider router={router} />
      </RegisterProvider>
    </AppProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
